import {GatsbyImage, getImage} from 'gatsby-plugin-image'
import React from 'react'
import styled from 'styled-components'

import Arrow from '../../images/inline-svgs/arrow-up-right.svg'

const DemoCard = ({image, imageAlt, title, link, color}) => {
  return (
    <Outer>
      <a href={link} target="_blank" rel="noopener">
        <Image>
          <GatsbyImage
            image={getImage(image)}
            alt={imageAlt}
            objectPosition="top left"
          />
        </Image>
        <Title color={color}>
          <span>{title}</span>
          <span>
            <Arrow />
          </span>
        </Title>
      </a>
    </Outer>
  )
}

export default DemoCard

const Outer = styled.div`
  width: 100%;
  padding: 12.5px;
  transition: transform 0.2s;

  &:hover {
    transform: translateY(-6px);
  }

  @media (min-width: ${p => p.theme.breakpoints.sm}) {
    width: 50%;
  }

  @media (min-width: ${p => p.theme.breakpoints.lg}) {
    width: 25%;
  }

  @media (min-width: ${p => p.theme.breakpoints.xl}) {
    padding: 25px;
  }
`

const Image = styled.div`
  height: 350px;
  overflow: hidden;
  border-radius: ${p => p.theme.radius.lg};
  box-shadow: ${p => p.theme.shadows.light};

  @media (min-width: ${p => p.theme.breakpoints.xl}) {
    height: 420px;
  }
`

const Title = styled.h4`
  margin: 16px 0 0;
  font-size: 1.8rem;
  color: ${p => p.color || p.theme.color.text.lighter};
  text-align: center;
  display: flex;
  align-items: flex-start;
  justify-content: center;

  span {
    padding: 0 2px;
  }
`
